/**
 * localStorage Preferences Utilities
 *
 * Story: 11.8 - LLM-Assisted Episode Editing
 * Acceptance Criteria: AC 3 - Task 4
 */

import { EPISODE_CREATION_PREFERENCE_KEY } from '../constants';
import { type EpisodeCreationMethod } from '../types/episode.types';

/**
 * Get episode creation preference from localStorage
 * Default: 'manual'
 */
export function getEpisodeCreationPreference(): EpisodeCreationMethod {
  try {
    const stored = localStorage.getItem(EPISODE_CREATION_PREFERENCE_KEY);
    return stored === 'generate' ? 'generate' : 'manual';
  } catch {
    // localStorage might not be available (e.g., in tests)
    return 'manual';
  }
}

/**
 * Set episode creation preference in localStorage
 */
export function setEpisodeCreationPreference(method: EpisodeCreationMethod): void {
  try {
    localStorage.setItem(EPISODE_CREATION_PREFERENCE_KEY, method);
  } catch {
    // localStorage might not be available (e.g., in tests)
    // Silently fail - preference won't persist
  }
}
